import { Chip } from '@mui/material';
import { OrderStatus } from '../data/models/orders/orderStatus';
import {
  orderStatusColor,
  orderStatusLabel,
} from '../data/helpers/orderHelpers';
import { useTranslation } from 'react-i18next';

interface OrderStatusProps {
  orderStatus: OrderStatus;
}

const OrderStatusLabel: React.FC<OrderStatusProps> = ({ orderStatus }) => {
  const color = orderStatusColor(orderStatus);
  const backgroundColor = `${color}20`;
  const { t } = useTranslation();

  return (
    <Chip
      label={t(orderStatusLabel(orderStatus))}
      sx={{
        color,
        backgroundColor,
        borderColor: color,
        height: '24px',
        '& .MuiChip-label': {
          padding: '0 8px',
          fontSize: '0.75rem',
        },
      }}
      variant="outlined"
      size="small"
    />
  );
};

export default OrderStatusLabel;
